export default {
 url: 'https://scusesoapp01prd.bunzlusa.com/api/v1',
 isR3App: false,
version : "1.1.51"
}